import { useSelector } from 'react-redux';
import { UserRoles } from '../../../data/enums';

const usePosMappingAccess = () => {
  const roles = useSelector((state) => state.authReducer.roles);
  const globalCompany = useSelector((state) => state.companyReducer.selected);
  const isAdmin = Array.isArray(roles) && roles.includes(UserRoles.ADMIN);
  const canEdit = isAdmin || Boolean(globalCompany?.allowposmappingedit);
  return { canEdit, isAdmin };
};

export default usePosMappingAccess;
